import React, { ChangeEvent, FC } from 'react';
import Grid from '@mui/material/Grid';
import { NormalButton } from 'components/atoms/Button';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface ISocialMediaInput {
  changeValue: (value: string, platform: string) => void;
  value: string;
  platformImg: string;
  editing: boolean;
  platform: string;
}

const SocialMediaInput: FC<ISocialMediaInput> = ({
  changeValue,
  platform,
  value,
  platformImg,
  editing,
}) => {
  const verifySvg = require('assets/icons/verify.svg');

  return (
    <Grid item xs={12} style={{ margin: '.5rem 0rem' }}>
      {(editing || value !== '') && (
        <NormalButton
          style={{
            // width: '100%',
            borderRadius: '30px',
            justifyContent: 'space-between',
          }}
        >
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            <img
              src={verifySvg.default}
              alt=""
              width="20px"
              height="20px"
              style={{ marginRight: '10px' }}
            />
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                height: '11px',
              }}
            >
              <span>@</span>
              {editing ? (
                <SocialInput
                  type="text"
                  name={platform}
                  value={value}
                  onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    changeValue(e.target.value, platform);
                  }}
                  disabled={!editing}
                />
              ) : (
                <p>{value}</p>
              )}
            </div>
          </Box>
          <img
            style={{ marginLeft: '20px' }}
            src={platformImg}
            alt=""
            width="20px"
            height="20px"
          />
        </NormalButton>
      )}
    </Grid>
  );
};

const SocialInput = styled('input')(() => ({
  backgroundColor: 'transparent',
  width: '80px',
  outline: 'none',
  border: '0',
  color: '#fff',
  textDecoration: 'none',
}));
export default SocialMediaInput;
